import React from 'react';


const About = ({ pageData }) => {
    return (
        <>
            <section className="about index2" style={{marginTop: "20px"}}>
                <div className='container-fluid'>
                    <div className="row">
                        <div className="col-lg-12" align="justify">
                            <div className='aboutHome'>
                                <h2>About</h2>
                                <p>{pageData && pageData.about}</p>
                            </div>
                        </div>
                    </div>  
                </div>
            </section>
        </>
    );
};

export default About;